<sb-card [loading]=loading>
  <div card-header>
    <div class="d-flex flex-row">
      <div class="mr-2"><b>{{ 'lang.globals.overview' | translate }}</b></div>
    </div>
  </div>
  <div card-body>
    <div class="row">
      <div class="col-xxl-4 col-xl-6 col-lg-6 col-md-12">
        <ng-container *ngIf="device">
          <div class="flex-grow-1 w-100">
            <div class="mt-4">
              <h5 class="mb-2">{{ 'lang.globals.data' | translate }}</h5>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{ 'lang.globals.identifier' | translate }}:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="device.identifier">
                    {{ device.identifier }}
                  </ng-container>
                  <i *ngIf="!device.identifier">
                    <a>&#91;{{ 'lang.deviceDetails.nDef' | translate }}.&#093;</a>
                  </i>
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  IP:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="device.lastIP">
                    {{ device.lastIP }}
                  </ng-container>
                  <i *ngIf="!device.lastIP">
                    <a>&#91;{{ 'lang.deviceDetails.nDef' | translate }}.&#093;</a>
                  </i>
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{ 'lang.globals.createdAt' | translate }}:
                </span>
                <span class="text-muted tr">
                  @if (device.createdAt) {
                    {{ device.createdAt.toString() | date: 'dd.MM.yy HH:mm' }}
                    @if (device.createdBy?.name) {
                      &nbsp;{{ 'lang.globals.of'|translate }} {{ device.createdBy?.name }}
                    }
                  } @else {
                    <i>
                    <a>&#91;{{ 'lang.deviceDetails.nDef' | translate }}.&#093;</a>
                  </i>
                  }
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{ 'lang.globals.paired' | translate }}:
                </span>
                <span class="text-muted tr">
                  @if (device.lastPairing) {
                    {{ device?.lastPairing?.timestamp.toString() | date: 'dd.MM.yy HH:mm' }}
                    @if (device.createdBy?.name) {
                      &nbsp;{{ 'lang.globals.of'|translate }} {{ device?.lastPairing?.causedBy?.name }}
                    }
                  } @else {
                    <i>
                    <a>&#91;{{ 'lang.deviceDetails.nDef' | translate }}.&#093;</a>
                  </i>
                  }
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{ 'lang.globals.lastOnline' | translate }}:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="device.lastOnline">
                    {{ device?.lastOnline.toString() | date: 'dd.MM.yy HH:mm' }}
                  </ng-container>
                  <i *ngIf="!device?.lastOnline">
                    <a>&#91;{{ 'lang.deviceDetails.nDef' | translate }}.&#093;</a>
                  </i>
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{ 'lang.globals.channel' | translate }}:
                </span>
                <span class="text-muted">
                  <ng-container
                    *ngIf="permissionService.hasPermission(permissionService.Permission.channel_show); else channelNoShowPermission">
                    <a [sbRouterLink]="util.RoutingID.channelDetailsOverview"
                       [pathParams]="[{id: 'channelID', value: device.channel.id}]">
                      {{ device.channel.name }}
                    </a>
                  </ng-container>
                  <ng-template #channelNoShowPermission>
                    <a>
                      {{ device.channel.name }}
                    </a>
                  </ng-template>
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{ 'lang.deviceDetails.pool' | translate }}:
                </span>
                <span class="text-muted">
                  @if (device.pool) {
                    @if (permissionService.hasPermissions([permissionService.Permission.pool_list, permissionService.Permission.device_list])) {
                      <a
                        [sbRouterLink]="util.RoutingID.devices"
                        [queryParams]="{'poolIds': getItemId(device?.pool)}">
                        {{ device.pool.name }}
                      </a>
                    } @else {
                      <a>
                        {{ device.pool.name }}
                      </a>
                    }
                  } @else {
                    <i>
                    <a>&#91;{{ 'lang.deviceDetails.nDef' | translate }}.&#093;</a>
                  </i>
                  }
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-dark-75 font-weight-bolder">
                  {{ 'lang.globals.location' | translate }}:
                </span>
                <span class="text-muted">
                  <ng-container *ngIf="device.location">
                    <ng-container
                      *ngIf="permissionService.hasPermission(permissionService.Permission.location_show); else locationNoShowPermission">
                      <a
                        [sbRouterLink]="util.RoutingID.locationDetails"
                        [pathParams]="[{id: 'locationID', value: device?.location?.id}]">
                        {{ device.location.name }}
                      </a>
                    </ng-container>
                    <ng-template #locationNoShowPermission>
                      <a>
                        {{ device.location.name }}
                      </a>
                    </ng-template>
                  </ng-container>
                  <i *ngIf="!device.location">
                    <a>&#91;{{ 'lang.deviceDetails.nDef' | translate }}.&#093;</a>
                  </i>
                </span>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="form-group mt-2">
          <label class="form-label" for="notes">Notes</label>
          <textarea class="form-control" id="notes" type="text"
                    [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit)" [(ngModel)]="notes"
                    [ngModelOptions]="{standalone: true}"></textarea>
          <button *ngIf="notes !== device?.notes && permissionService.hasPermission(permissionService.Permission.device_properties_edit)"
                  type="button" class="mt-1 btn btn-primary" (click)="saveNotes()">
            <sb-icon icon="save" class="icon-in-btn"></sb-icon>
            {{ 'lang.globals.save'|translate }}
          </button>
        </div>
      </div>
      <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-12">
        <ng-container *ngIf="device">
          <div class="flex-grow-1 w-100">
            <div class="mt-4">
              <h5 class="mb-2">{{ 'lang.globals.status' | translate }}</h5>
              <div class="d-flex justify-content-between align-items-center mb-1">
            <span class="text-dark-75 font-weight-bolder">
              <sb-icon *ngIf="device.paired" icon="success" class="green"></sb-icon>
              <sb-icon *ngIf="!device.paired" icon="error" class="grey"></sb-icon>
              {{ 'lang.deviceDetails.paired' | translate }}
            </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
            <span class="text-dark-75 font-weight-bolder">
              <sb-icon *ngIf="device.productive" icon="success" class="green"></sb-icon>
              <sb-icon *ngIf="!device.productive" icon="error" class="grey"></sb-icon>
              {{ 'lang.deviceDetails.productive' | translate }}
            </span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
            <span class="text-dark-75 font-weight-bolder">
              <sb-icon *ngIf="device.offline" icon="success" class="green"></sb-icon>
              <sb-icon *ngIf="!device.offline" icon="error" class="grey"></sb-icon>
              {{ 'lang.deviceDetails.noSim' | translate }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-1">
            <span class="text-dark-75 font-weight-bolder">
              <sb-icon *ngIf="device.external" icon="success" class="green"></sb-icon>
              <sb-icon *ngIf="!device.external" icon="error" class="grey"></sb-icon>
              {{ 'lang.deviceDetails.external' | translate }}
            </span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="col-xxl-4 col-xl-6 col-lg-6 col-md-12">
        <div class="flex-grow-1 w-100">
          <ng-container *ngIf="device">
            <div class="mt-4">
              <h5 class="mb-2">{{ 'lang.deviceDetails.validPlayerFilters' | translate }}</h5>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <ng-scrollbar style="height: 300px;" class="w-100">
                  <ng-container *ngIf="culls">
                    <div *ngFor="let cull of culls; first as first">
                      <hr *ngIf="first" class="border-dashed">
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <span class="text-dark-75 font-weight-bolder">
                          <a
                            *ngIf="permissionService.hasPermission(permissionService.Permission.cull_list); else cullNoShowPermission"
                            [sbRouterLink]="util.RoutingID.filterDetails"
                            [pathParams]="[{id: 'filterID', value: cull.id}]">
                            {{ cull.name }}
                          </a>
                          <ng-template #cullNoShowPermission>
                            <a>
                              {{ cull.name }}
                            </a>
                          </ng-template>
                        </span>
                      </div>
                      <hr class="border-dashed">
                    </div>
                  </ng-container>
                </ng-scrollbar>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</sb-card>
